import { render, staticRenderFns } from "./Static.vue?vue&type=template&id=71560cc2&scoped=true"
import script from "./Static.vue?vue&type=script&lang=js"
export * from "./Static.vue?vue&type=script&lang=js"
import style0 from "./Static.vue?vue&type=style&index=0&id=71560cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71560cc2",
  null
  
)

export default component.exports